<template>
  <div style="min-height: 100vh; background: #003963">
      <Form />
  </div>
</template>

<script>
import Form from './form'
export default {
    name: 'FormPage',
    components: {
        Form
    }
}
</script>

<style>

</style>